<style scoped>
    .ajax-btn{
        display: inline-block;
    }
    .ajax-btn span{
        margin: 0 !important;
    }
    .ivu-btn>.ivu-icon+span, .ivu-btn>span+.ivu-icon {
        margin-left: 0;
    }
</style>
<template>
    <div class="ajax-btn" v-show="show">
        <Button 
            :type="btnType" 
            :size="setting.size" 
            :shape="setting.shape"
            :loading="isProcessing" 
            :icon="setting.icon"
            @click="buttonClick">
            <span class="btn-text" v-show="!isProcessing && !isSuccessed && !isFailed">{{setting.name}}</span>
            <span class="btn-text" v-show="isProcessing">{{setting.processingName}}</span>
            <span class="btn-text" v-show="isSuccessed">{{setting.successedName}}</span>
            <span class="btn-text" v-show="isFailed">{{setting.failedName}}</span>
        </Button>
    </div>
</template>
<script>
    import Util from '../../libs/util';
    export default {
        props: {
            url: {
                type: String,
                required: true
            },
            params: {
                type: Object
            },
            type: {
                type: String
            },
            config: {
                type: Object
            },
            vShow: {
                type: Boolean,
                default: true
            }
        },
        data () {
            return {
                isProcessing: false,
                isSuccessed: false,
                isFailed: false,

                setting: {
                    method: 'POST',
                    timeout: 10000,
                    //显示执行操作的确认框
                    confirm: false,
                    confirmContent: '你确认要执行此操作吗?',
                    //确认操作的函数, 发送请求前执行, 返回 true 才会执行请求
                    checkCallback: '',
                    name: '提交',
                    processingName: 'Loading...',
                    successedName: '提交成功',
                    failedName: '提交失败',
                    size: undefined,
                    shape: undefined,
                    type: 'primary',
                    icon: ''
                },
                type_config_hash: {
                    search: {
                        icon: 'ios-search',
                        method: 'get',
                        name: '搜索',
                        processingName: '搜索中...',
                        successedName: '搜索',
                        failedName: '搜索失败'
                    },
                    submit: {
                        method: 'post',
                        name: '提交',
                        processingName: '提交中...',
                        successedName: '提交成功',
                        failedName: '提交失败'
                    },
                    update: {
                        method: 'post',
                        name: '保存',
                        processingName: '保存中...',
                        successedName: '保存成功',
                        failedName: '保存失败'
                    }
                }
            }
        },
        computed: {
            btnType(){
                if(this.isSuccessed){
                    return 'success';
                }else if(this.isFailed){
                    return 'error';
                }else{
                    return this.setting.type;
                }
            },
            show(){
                return !!(this.vShow || this.vShow === undefined);
            },
            ajaxConfig(){
                let config = {
                    url: this.url,
                    method: this.setting.method,
                    timeout: this.setting.timeout,
                };
                if(config.method.toLowerCase() === 'post'){
                    config.data = this.params;
                }else{
                    config.params = this.params;
                }
                return config;
            }
        },
        created(){
            this.init();
        },
        methods: {
            init(){
                if(this.type){
                    let type_config = this.type_config_hash[this.type];
                    type_config && Object.assign(this.setting, type_config);
                }
                this.config && Object.assign(this.setting, this.config);
            },
            buttonClick(){
                this.$emit('click');
                if(this.setting.confirm){
                    this.$Modal.confirm({
                        title: '提示',
                        content: this.setting.confirmContent,
                        onOk: ()=>{
                            setTimeout(()=>{
                                this.doAjax();
                            }, 1000);
                        }
                    })
                }else{
                    this.doAjax();
                }
            },
            doAjax(cancel_before){
                if(!this.url){
                    this.$Message.error('请在 props 中指定 URL 路径');
                    return;
                }
                //如果规定了 checkCallback, checkCallback 需返回 true 才会往下执行
                if(this.setting.checkCallback && !this.setting.checkCallback()){
                    return;
                }

                if(!this.isProcessing && !this.isSuccessed){
                    if(!cancel_before){
                        this.$emit('before');
                    }
                    this.isProcessing = true;
                    Util.ajax(this.ajaxConfig).then((response)=>{
                        if(Util.isObject(response.data)){
                            return response.data;
                        }else{
                            try{
                                return JSON.parse(response.data);
                            }catch(e){
                                return response.data;
                            }
                        }
                    }).then((res)=>{
                        this.isProcessing = false;
                        if(res.code === 1){
                            this.isSuccessed = true;
                            this.$emit('done', res.data);
                            setTimeout(()=>{
                                this.isSuccessed = false;
                            }, 500);
                        }else{
                            /*this.$Modal.error({
                                title: '错误',
                                content: res.msg
                            });*/
                            this.$emit('fail', {message: res.msg});
                        }
                    }).catch((e)=>{
                        console.log(e);
                        this.isProcessing = false;
                        this.isFailed = true;
                        this.$emit('fail', e);
                        setTimeout(()=>{
                            this.isFailed = false;
                        }, 2000);
                    }).finally(()=>{
                        this.$emit('finally');
                    });
                }
            }
        }
    }
</script>
